<div class="container-fluid psp-container">
  <div class="card mb-4">
    <div class="row align-items-center pt-3">
      <div class="col-lg-6 col-7">
        <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-3">
          <ol class="breadcrumb breadcrumb-links breadcrumb-dark">
            <li class="breadcrumb-item text-primary psp-breadcrumb">
              <a class="text-primary" [routerLink]="'/patients'"
                *ngIf="patientScreenType == patientScreenTypesEnum.LimitlesscarePatients"> Patients </a>
              <a class="text-primary" [routerLink]="'/psp/psp-patients'"
                *ngIf="patientScreenType == patientScreenTypesEnum.PspPatients"> PSP Patients </a>
              <a class="text-primary" [routerLink]="'/lca-patients'"
                *ngIf="patientScreenType == patientScreenTypesEnum.LcaPatients"> LCA Patients </a>
            </li>
            <li aria-current="page" class="breadcrumb-item active text-gray psp-breadcrumb">
              Patient Profile
            </li>
          </ol>
        </nav>
      </div>
    </div>
    <div class="border-bottom title d-flex p-3 justify-content-between align-items-center mt-2">
      <h2 class="m-0">Patient Profile</h2>
      <div>
        <div class="filter-list-container d-flex justify-content-between">
          <button class="btn btn-icon" [ngClass]="{ active: pageId == 1 }" type="button" (click)="pageId = 1">
            <span class="btn-inner--text"> Profile Details </span>
          </button>
          <button *ngIf="patientScreenType == patientScreenTypesEnum.PspPatients" class="btn btn-icon" type="button"
            [ngClass]="{ active: pageId == 2 }" (click)="pageId = 2">
            <span class="btn-inner--text"> PSPs </span>
          </button>
          <button class="btn btn-icon" type="button" [ngClass]="{ active: pageId == 3 }" (click)="pageId = 3">
            <span class="btn-inner--text"> EMR </span>
          </button>
          <button *ngIf="patientScreenType == patientScreenTypesEnum.LcaPatients" class="btn btn-icon"
            class="btn btn-icon" [ngClass]="{ active: pageId == 4 }" type="button" (click)="pageId = 4">
            <span class="btn-inner--text"> Approvals </span>
          </button>
        </div>
      </div>
    </div>

    <ng-template [ngIf]="pageId == 1">
      <div class="card-body">
        <h2>Profile details</h2>
        <div class="card-patient p-3">
          <div class="pr-3 edit-btn">
            <span class="btn-inner--icon">
              <i class="btn btn-outline-default fas fa-edit edit-icon"
                (click)="openEditPatientNotificationModal(editPatientDetailsModal)"> </i>
            </span>
          </div>
          <div class="p-3 border-bottom" id="personal-details">
            <h3>Personal Details</h3>
            <div class="row justify-content-evenly">
              <div class="col-md-3">
                <label for="fName">Full Name</label>
                <span id="fName">{{ patient?.personalInfo?.fullName }}</span>
              </div>
              <div class="col-md-3">
                <label for="nID">National ID / Passport ID</label>
                <span id="nID">{{ nationalIdAndPassportId || '--' }}</span>
              </div>
              <div class="col-md-3">
                <label for="dob">Date of Birth</label>
                <span id="dob">{{
                  (patient?.personalInfo?.birthdate | date) || '--'
                  }}</span>
              </div>
              <div class="col-md-3">
                <label for="patientType">Patient Type</label>
                <span id="patientType">{{
                  patient?.personalInfo?.patientType || '--'
                  }}</span>
              </div>
            </div>
            <div class="row justify-content-evenly mt-3">
              <div class="col-md-3" *ngFor="let pspComany of patient?.personalInfo?.pspCompany">
                <label for="pspCode">{{pspComany.companyName}} PSP Code</label>
                <span id="pspCode">{{pspComany.pspCode}}</span>
              </div>
            </div>
          </div>
          <div class="p-3 border-bottom" id="phone-details">
            <h3>Phone Details</h3>
            <div class="row justify-content-evenly">
              <div class="col-md-3">
                <label for="phone">Phone</label>
                <span id="phone">{{ patient?.personalInfo?.phone || '--' }}</span>
              </div>
            </div>
          </div>

          <div class="p-3" id="location">
            <h3>Location</h3>
            <div class="row justify-content-evenly">
              <div class="col-md-3">
                <label for="city">City</label>
                <span id="city">{{ patient?.personalInfo?.cityName || '--' }}</span>
              </div>
              <div class="col-md-3">
                <label for="area">Area</label>
                <span id="area">{{ patient?.personalInfo?.areaName || '--' }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-5" id="saved-address">
          <h2>Saved Addresses</h2>
          <div class="address-container d-flex flex-wrap">
            <div class="address-card" *ngFor="let address of patient?.addresses; let i = index">
              <div class="card-header">
                <div class="more-menu-trigger row d-flex justify-content-between pr-3 pl-3">
                  <h3>{{ address?.title }}</h3>
                  <span (click)="openMenuItem(i)"><i class="icon-show-more"></i></span>
                  <div class="more-menu" *ngIf="moreMenuItems[i]">
                    <ul>
                      <li (click)="
                          openNotificationModal(
                            addAddressModal,
                            true,
                            address,
                            true
                          );
                          openMenuItem(i)
                        ">
                        <span><i class="icon-view"></i></span>View Address
                      </li>
                      <li (click)="
                          openNotificationModal(addAddressModal, true, address);
                          openMenuItem(i)
                        ">
                        <span><i class="icon-create"></i></span>Edit Address
                      </li>
                      <li (click)="
                          openNDeleteModal(
                            deleteAddressModal,
                            address.patientAddressId
                          );
                          openMenuItem(i)
                        ">
                        <span><i class="icon-delete"></i></span>Delete Address
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-6">
                    <label for="city">City</label>
                    <span id="city">{{ address?.cityName }}</span>
                  </div>
                  <div class="col-md-6">
                    <label for="area">Area</label>
                    <span id="area">{{ address?.areaName }}</span>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-md-12">
                    <label for="address">Address</label>
                    <span id="address">{{ address?.details }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="add-address address-card d-flex flex-column justify-content-center align-items-center"
              (click)="openNotificationModal(addAddressModal)">
              <span class="mb-3">
                <i class="icon-add-address"></i>
              </span>
              <h3 class="cta-address">Add New Address</h3>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template [ngIf]="pageId == 2">
      <app-patient-subscriptions (addNewAddress)="
          openNotificationModal(
            addAddressModal,
            (editMode = false),
            (address = null),
            (viewOnly = false),
            (returnToSub = true)
          )
        " [patientId]="patientId" [addresses]="patient?.addresses">
      </app-patient-subscriptions>
    </ng-template>
    <patient-emr *ngIf="pageId == 3"></patient-emr>
    <app-approvals *ngIf="pageId == 4"></app-approvals>
  </div>
</div>

<ng-template #addAddressModal>
  <div class="modal-header align-items-center lookup-header">
    <h6 class="pointer" *ngIf="returnToSub" (click)="notificationModal.hide()">
      Back To Saved Addresses
    </h6>
    <button aria-label="Close" class="close" data-dismiss="modal" type="button" (click)="notificationModal.hide()">
      <span class="" aria-hidden="true"> × </span>
    </button>
  </div>

  <div class="modal-body add-address-modal">
    <div class="lookup-card d-flex align-items-center flex-column bg-white">
      <h1>
        {{
        editMode && !readOnly
        ? "Edit Address"
        : readOnly
        ? "Address Details"
        : "Add New Address"
        }}
      </h1>
      <p>
        {{
        editMode && !readOnly
        ? "Updating below data is on your responsibility and you can’t undo this action once it’s saved."
        : readOnly
        ? ""
        : "Please add customers address details below"
        }}
      </p>
      <form #addressForm="ngForm">
        <div class="row">
          <div class="col-md-6">
            <label for="title">Address Title (ex: Home, Work ..etc)</label>
            <input type="text" name="title" id="title" [(ngModel)]="newAddress.title" required
              class="w-100" #title="ngModel" appCheckValidity [appCheckValidity]="title" [readonly]="readOnly" />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label for="title">City</label>
            <select name="city" id="city" (change)="onCityChange($event.target.value)" [disabled]="readOnly">
              <option disabled selected>Select City</option>

              <option *ngFor="let city of cityList" [selected]="newAddress.cityId == city.id" [value]="city.id">
                {{ city.enName }}
              </option>
            </select>
          </div>
          <div class="col-md-6">
  <label for="title">Area</label>
  <select name="areaId" id="area" (change)="onAreaChange($event.target.value)" [disabled]="readOnly" [(ngModel)]="newAddress.areaId">
    <option disabled [selected]="!newAddress?.areaId">
      Select Area
    </option>
    <option *ngFor="let area of areaList" [value]="area.id">
      {{ area.enName }}
    </option>
  </select>
</div>

        </div>
        <div class="row">
          <div class="col-md-12">
            <label for="address">Address</label>
            <textarea name="address" id="address" cols="30" rows="2" [(ngModel)]="newAddress.details"
              required #address="ngModel" appCheckValidity [appCheckValidity]="address"
              [readonly]="readOnly"></textarea>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label for="bNum">Building Number</label>
            <input required type="text" name="bNum" id="bNum" class="w-100"
              [(ngModel)]="newAddress.buildingNumber" #bNum="ngModel" appCheckValidity
              [appCheckValidity]="bNum" [readonly]="readOnly" />
          </div>

          <div class="col-md-6">
            <label for="floorNum">Floor Number</label>
            <input required type="number" name="floorNum" id="floorNum" class="w-100"
              [(ngModel)]="newAddress.floorNumber" #floorNum="ngModel" appCheckValidity
              [appCheckValidity]="floorNum" [readonly]="readOnly" appMin="0" min="0" />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label for="apNum">Apartment Number</label>
            <input type="number" name="apNum" id="apNum" class="w-100"
              [(ngModel)]="newAddress.apartmentNumber" #apNum="ngModel" appCheckValidity
              [appCheckValidity]="apNum" [readonly]="readOnly" appMin="0" min="0" />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label for="additionalDetails">Additional Details</label>
            <textarea name="additionalDetails" id="additionalDetails" cols="30" rows="2"
              [(ngModel)]="newAddress.additionalDetails" [readonly]="readOnly"></textarea>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center flex-column">
    <button [ngClass]="{ loading: loading }" type="submit" class="btn btn-psp-primary btn-round"
      [disabled]="!addressForm.valid" (click)="onSubmit(addressForm)" *ngIf="!readOnly">
      {{ editMode ? "Edit" : "Save" }}
    </button>

    <button type="submit" class="btn btn-psp-primary btn-round" (click)="notificationModal.hide()" *ngIf="readOnly">
      Close
    </button>
  </div>
</ng-template>

<ng-template #deleteAddressModal>
  <div class="modal-header align-items-center lookup-header">
    <button aria-label="Close" class="close" data-dismiss="modal" type="button" (click)="notificationModal.hide()">
      <span class="" aria-hidden="true"> × </span>
    </button>
  </div>

  <div class="modal-body add-address-modal mt--3">
    <div class="lookup-card d-flex align-items-center flex-column bg-white">
      <h2>Are you sure?</h2>
      <p>
        You’re about to delete a saved address entered by the user. And you
        can’t undo this action.
      </p>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center flex-column mt--3">
    <button type="submit" class="btn btn-psp-primary btn-round" (click)="onDeleteAddress()">
      Delete Address
    </button>
  </div>
</ng-template>

<ng-template #editPatientDetailsModal>
  <div class="modal-header align-items-center lookup-header">
    <button aria-label="Close" class="close" data-dismiss="modal" type="button" (click)="notificationModal.hide()">
      <span class="" aria-hidden="true"> × </span>
    </button>
  </div>

  <div class="modal-body edit-patient-modal">
    <div class="lookup-card d-flex align-items-center flex-column bg-white">
      <h1>Edit patient's profile details</h1>
      <p>Updating below data is on your responsibility and you can’t undo this action once it’s saved.</p>
      <form class="mt-3" [formGroup]="editPatientProfileForm" (ngSubmit)="onSubmitEditPatient()">
        <div class="row ">
          <div class="col-md-6">
            <div>
              <label for="full-name">Full Name</label>
              <input type="text" formControlName="fullName" id="full-name" class="w-100" placeholder="Full Name" />
            </div>
          </div>

          <div class="col-md-6">
            <div>
              <div class="d-flex justify-content-between mb-0">
                <label for="nationalId" *ngIf="!editPatientProfileForm.value.isPassportId; else passportIdBlock">
                  National ID
                </label>
                <ng-template #passportIdBlock>
                  <label for="passportId">
                    Passport ID
                  </label>
                </ng-template>

                <label class="custom-toggle custom-toggle-default custom-toggle-95 toggle-position">
                  <input type="checkbox" formControlName="isPassportId" />
                  <span class="custom-toggle-slider rounded-circle" data-label-off="Passport Id"
                    data-label-on="National Id">
                  </span>
                </label>
              </div>

              <input *ngIf="!editPatientProfileForm.value.isPassportId; else passportIdInputBlock"
                formControlName="nationalId" placeholder="National ID" id="nationalId" type="number" name="nationalId"
                class="w-100" />
              <ng-template #passportIdInputBlock>
                <input formControlName="passportId" id="passportId" type="text" name="passportId" class="w-100"
                  placeholder="Passport ID" />
              </ng-template>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div>
              <label for="title">City</label>
              <select formControlName="cityId" name="city" id="city" (change)="onCityChange($event.target.value)">
                <option disabled [selected]="!patient.personalInfo?.cityId">Select City</option>

                <option *ngFor="let city of cityList" [selected]="patient.personalInfo?.cityId == city.id"
                  [value]="city.id">
                  {{ city.enName }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-6">
  <div>
    <label for="title">Area</label>
    <select formControlName="areaId" name="areaId" id="area" (change)="onAreaChange($event.target.value)">
      <option value="" >Select Area</option>
      <option *ngFor="let area of areaList" [value]="area.id">
        {{ area.enName }}
      </option>
    </select>
  </div>
</div>

        </div>

        <div class="row">
          <div class="col-md-6">
            <div>
              <label class="form-control-label" for="dob">
                Date Of Birth
              </label>
              <input id="dob" type="date" name="dob" formControlName="birthDate" class="w-100" />
            </div>
          </div>
        </div>

        <div class="modal-footer d-flex justify-content-center flex-column">
          <button [ngClass]="{ loading: loading }" type="submit" class="btn btn-psp-primary btn-round"
            [disabled]="editPatientProfileForm.invalid">
            Edit
          </button>

          <!-- <button
            type="submit"
            class="btn btn-psp-primary btn-round"
            (click)="notificationModal.hide()"
            *ngIf="readOnly"
          >
            Close
          </button> -->
        </div>
      </form>
    </div>
  </div>

</ng-template>



<ngx-spinner></ngx-spinner>
